import { SurveyStatus, SurveyValidationResult } from './constants';
import {getData} from "../../common/services/network.service";
import {SurveyParametersResponse} from "./models";

// order validation result for MM
const orderValidationResults = [
    SurveyValidationResult.OK,
    SurveyValidationResult.TRANSLATION_MISSING,
    SurveyValidationResult.SURVEY_STRUCTURE_INVALID,
    SurveyValidationResult.MISSING_TARGET,
    SurveyValidationResult.UNKNOWN,
];

const getSurveyStatus = (statuses: Set<SurveyStatus>) => {
    if (statuses.has(SurveyStatus.LIVE)) {
        return SurveyStatus.LIVE;
    }

    if (statuses.has(SurveyStatus.SCHEDULED)) {
        return SurveyStatus.SCHEDULED;
    }

    if (statuses.has(SurveyStatus.PAUSED)) {
        return SurveyStatus.PAUSED;
    }

    return statuses.has(SurveyStatus.ENDED) ? SurveyStatus.ENDED : SurveyStatus.PENDING;
};

export const getSurveyParametersById = (
    surveyId: string | number,
    onSuccess: (response: SurveyParametersResponse) => void,
    onError: (response: any) => void
) => {
        const { LAUNCH_BASE_API_URL, PROJECT_GW_BASE_API_URL } = window.ts.globals;

        const isHoustonOnEnabled = window.tcp?.user?.userDetailsTraits?.traits?.IsHoustonOnEnabled ?? false;

        const url = isHoustonOnEnabled
            ? `${PROJECT_GW_BASE_API_URL}/launch/${surveyId}/parameters`
            : `${LAUNCH_BASE_API_URL}projects/${surveyId}/launch/parameters`;

        getData(
            url,
            response => {
                const surveysIds = Object.keys(response.surveyLaunchParams).map(Number);
                const surveys: any = Object.values(response.surveyLaunchParams);
    
                const surveyStatuses = new Set<SurveyStatus>();
                const validationResults = new Set();
    
                surveys.forEach((survey: any) => {
                    surveyStatuses.add(survey.surveyStatus);
                    validationResults.add(survey.surveyLaunchValidationResult);
                });
    
                const validationResult = orderValidationResults.find(v => validationResults.has(v));

                onSuccess({
                    surveysIds,
                    validationResult,
                    status: getSurveyStatus(surveyStatuses),
                    isMultimarket: response.isMultimarketSurvey ?? response.isMultiMarketSurvey,
                    isAdvancedTargetingEnabled: surveys[0]?.advancedTargetingEnabled ?? false,
                });
            },
            onError,
            { isTransformCamelCase: true },
        );
};
